import { API_URL } from 'AppConstant'

/** GCS console URLs redirect to Google login; use the direct object URL instead. */
export function encodeMediaUrl(url: string): string {
  try {
    const parsed = new URL(url)

    if (parsed.hostname === 'storage.cloud.google.com') {
      parsed.hostname = 'storage.googleapis.com'
    }

    parsed.pathname = parsed.pathname
      .split('/')
      .map((segment) => {
        if (!segment) return segment
        try {
          return encodeURIComponent(decodeURIComponent(segment))
        } catch {
          return encodeURIComponent(segment)
        }
      })
      .join('/')

    return parsed.toString()
  } catch {
    return url
  }
}

export function resolveShopMediaUrl(url?: string | null): string | undefined {
  if (!url || typeof url !== 'string') return undefined
  const trimmed = url.trim()
  if (!trimmed) return undefined

  if (/^https?:\/\//i.test(trimmed)) {
    return encodeMediaUrl(trimmed)
  }

  const origin = API_URL.replace(/\/api\/?$/i, '')
  if (!origin) return trimmed

  const absolute = `${origin}${trimmed.startsWith('/') ? trimmed : `/${trimmed}`}`
  return encodeMediaUrl(absolute)
}
